<script setup lang="ts">
interface Props {
  author: string;
  body: ProductQuestionAnswer['text'];
  publishedDate: ProductQuestionAnswer['createdAt'];
}

const { author, body, publishedDate } = defineProps<Props>()

const localePublishedDate = useLocaleDate(new Date(publishedDate))
</script>

<template>
  <div class="ml-10">
    <div class="border-b border-gray-400 mb-[15px]">
      <div class="flex pb-[15px]">
        <div class="flex-auto">
          <span class="block text-primary font-medium text-16 first-letter:uppercase">{{ author }}</span>
          <span>{{ localePublishedDate }}</span>
        </div>
        <span class="uppercase">Odpowiedź</span>
      </div>
      <p class="pb-[9.5px]">
        {{ body }}
      </p>
    </div>
  </div>
</template>
